import moment from 'moment';
import DataGrid from 'react-data-grid';
import Gravatar from 'react-gravatar';

import InviteApi from 'api/invite';

import CreateButton from 'components/ui/buttons/CreateButton';
import NoRecords from 'components/ui/DataGrid/NoRecords';
import withContentLoader from 'components/ui/withContentLoader';
import withAuthorizer from 'components/ui/withAuthorizer';
import NotificationHelper from 'helpers/NotificationHelper';

import { Resources } from 'helpers/ResourceHelper';
import { useTranslation } from 'react-i18next';
import { useMutation, useQueryClient } from 'react-query';

const InvitesTab = ({ data = [] }) => {
  const { t } = useTranslation();
  const queryClient = useQueryClient();

  const mutationParams = {
    onSuccess: () => {
      queryClient.invalidateQueries('invites');
    },
  };

  const resendMutation = useMutation(async id => {
    try {
      await InviteApi.resend(id);
      NotificationHelper.snack(t(`admin.invites.messages.invite_sent`));
    } catch (error) {
      NotificationHelper.snack(t(`messages.unexpected_error`));
    }
  }, mutationParams);

  const UserFormatter = ({ row }) => {
    const inviter = row.inviter || {};
    return (
      <>
        <Gravatar email={inviter.email || 'unkown@youfy.com.br'} size={32} default="mm" className="rounded-circle shadow-sm" />
        <div className="ms-2">{inviter.name}</div>
      </>
    );
  };

  const ActionsFormatter = ({ row }) => {
    const resend = () => resendMutation.mutate(row.id);

    return (
      <>
        <button type="button" disabled={false} className="btn btn-outline-primary" onClick={resend}>
          {t('actions.resend')}
        </button>
      </>
    );
  };

  const columns = [
    { key: 'email', name: 'Email' },
    { key: 'user.name', name: t('admin.invites.columns.invited_by'), formatter: UserFormatter },
    {
      key: 'created_at',
      name: t('admin.invites.columns.date'),
      formatter: ({ row }) => <div>{moment(row.created_at).format('DD/MM/YYYY HH:mm')}</div>,
    },
    { key: 'actions', name: '', formatter: ActionsFormatter },
  ];

  return (
    <>
      <DataGrid columns={columns} rows={data} className="data-grid rdg-light" rowName="row" rowHeight={60} emptyRowsRenderer={NoRecords} />
      <CreateButton to="/admin/members/invite/new" />
    </>
  );
};

const fetchData = async () => InviteApi.fetch();
const page = withContentLoader(InvitesTab, { name: 'invites', fetchData });
export default withAuthorizer(page, [Resources.USER_MANAGER]);
